/**
 * Un seul tiroir latéral à la fois (TabletShell).
 *
 * @remarks
 * Les tiroirs suivent le layout store, partagé avec le desktop où les deux
 * panneaux coexistent. Quand les deux se retrouvent affichés, celui qu'on vient
 * d'ouvrir l'emporte et l'autre est refermé dans le store, pour que le bouton
 * du header reflète ce qui est affiché. Sans ouverture identifiable (arrivée
 * depuis le desktop, restauration d'un contexte), le gauche reste.
 */

import { useEffect, useRef } from 'react';
import { useLayoutStore } from '@/app/stores/use-layout-store';

export function useExclusiveDrawers(showLeft: boolean, showRight: boolean): void {
  const setLeftDrawerOpen = useLayoutStore((s) => s.setLeftDrawerOpen);
  const setRightDrawerOpen = useLayoutStore((s) => s.setRightDrawerOpen);
  const previous = useRef({ left: showLeft, right: showRight });

  useEffect(() => {
    const before = previous.current;
    previous.current = { left: showLeft, right: showRight };
    if (!showLeft || !showRight) return;
    const rightJustOpened = before.left && !before.right;
    if (rightJustOpened) setLeftDrawerOpen(false);
    else setRightDrawerOpen(false);
  }, [showLeft, showRight, setLeftDrawerOpen, setRightDrawerOpen]);
}
